import React from 'react';
import SolutionDetail from '../components/SolutionDetail';
import SettingsRemoteIcon from '@mui/icons-material/SettingsRemote';

const solutionData = {
  id: 'drone-mapping',
  name: 'Drone Mapping',
  icon: <SettingsRemoteIcon sx={{ fontSize: 60 }} />,
  description: 'High-resolution imagery mapping for smaller area projects',
  overview: `Geomaps operates a mapping drone capable of high resolution imagery mapping for smaller area projects. Our drone system combines aerial photography and LiDAR mapping capabilities with RTK-enabled precision, making it ideal for detailed mapping of smaller areas where high accuracy is crucial.`,
  features: [
    {
      title: 'Dual Mapping Capability',
      description: 'Both aerial photography and LiDAR mapping in one platform',
    },
    {
      title: 'RTK-Enabled',
      description: 'Onboard GNSS receiver collecting data from all available satellite constellations',
    },
    {
      title: 'High Resolution',
      description: 'Centimeter-level accuracy in aerial imagery',
    },
    {
      title: 'LiDAR Scanning',
      description: 'High density 3D terrain mapping capabilities',
    },
    {
      title: 'Small Area Specialization',
      description: 'Perfect for detailed mapping of smaller scale projects',
    },
  ],
  benefits: [
    'Centimeter-level accuracy',
    'Real-time kinematic positioning',
    'Comprehensive satellite constellation coverage',
    'Efficient small-area mapping',
    'Combined photo and LiDAR data collection',
  ],
};

const DroneMapping = () => {
  return <SolutionDetail solution={solutionData} />;
};

export default DroneMapping; 